var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgParentalLeave = function SvgParentalLeave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 9c0 1.657-1.79 3-4 3s-4-1.343-4-3 1.79-3 4-3 4 1.343 4 3Zm-3-1.5c0 .276-.448 1-1 1s-1-.724-1-1 .448-.5 1-.5 1 .224 1 .5Z",
    clipRule: "evenodd",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16 8.5c.552 0 1-.724 1-1s-.448-.5-1-.5-1 .224-1 .5.448 1 1 1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22 30c1.657 0 3-1.79 3-4s-1.343-4-3-4-3 1.79-3 4 1.343 4 3 4Z",
    opacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.573 1.563C11.979.632 10.825 0 9.5 0 7.567 0 6 1.343 6 3c0 1.096.685 2.054 1.709 2.578A6.419 6.419 0 0 0 7 8.5c0 2.039.976 3.888 2.56 5.24-.88.124-1.798.488-2.636 1.093-2.167 1.564-2.972 4.15-1.799 5.775.206.285.459.522.748.71C4.731 22.418 4 24.106 4 26c0 3.314 2.239 6 5 6 1.304 0 2.492-.6 3.382-1.581.95.393 2.006.581 3.118.581s2.168-.188 3.118-.581C19.508 31.4 20.696 32 22 32c2.761 0 5-2.686 5-6 0-1.872-.715-3.544-1.835-4.645a2.79 2.79 0 0 0 .808-.747c1.173-1.625.368-4.21-1.8-5.775a6.184 6.184 0 0 0-1.918-.94C23.948 12.528 25 10.617 25 8.5a6.42 6.42 0 0 0-.709-2.922C25.315 5.054 26 4.096 26 3c0-1.657-1.567-3-3.5-3-1.326 0-2.479.632-3.073 1.563A10.553 10.553 0 0 0 16 1c-1.213 0-2.37.2-3.427.563ZM16 12c2.21 0 4-1.343 4-3s-1.79-3-4-3-4 1.343-4 3 1.79 3 4 3Zm0-3.5c.552 0 1-.724 1-1s-.448-.5-1-.5-1 .224-1 .5.448 1 1 1ZM25 26c0 2.21-1.343 4-3 4s-3-1.79-3-4 1.343-4 3-4 3 1.79 3 4ZM9 30c1.657 0 3-1.79 3-4s-1.343-4-3-4-3 1.79-3 4 1.343 4 3 4Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9 30c1.657 0 3-1.79 3-4s-1.343-4-3-4-3 1.79-3 4 1.343 4 3 4Z",
    opacity: 0.4
  })));
};
export default SvgParentalLeave;